export default __webpack_public_path__ + "static/media/money-bag-dollar-active.ff2d89a1.svg";